import useJwt from '@/auth/jwt/useJwt'
import router from '@/router/index'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = user => {
  if (user.main_group === null) return {name: 'auth-roll'}
  if (user.main_group.name === 'brand' && user.account_company === null) return {name: 'account-company'}

  if (user.main_group.name === 'realty') {
    if (user.account_company === null) return {name: 'account-company'}
    // else if (localStorage.getItem('accept_tyc') === 'false') return {name: 'terms-conditions'}
    else return {name: 'campaigns'}
  }

  if (user.main_group.name === 'creator' || user.account_company !== null) {
    // if (localStorage.getItem('accept_tyc') === 'false') return {name: 'terms-conditions'}
    return {name: 'dashboard-analytics'}
  }
  
  return {name: 'auth-login'}
}

export const tokenExpired = () => {
  localStorage.clear()
  router.push({name: 'auth-login'})
}
